import axios from '~/axiosWrapper';
import { API } from '~/app/routes';
import { jsonToFormData } from '~/app/helpers/headerContentType';
import { PeriodicChecksPayload, PeriodicCheckSaveResponse } from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export class PeriodicCheckRemoteDataSource {
  save(payload: PeriodicChecksPayload): Promise<PeriodicCheckSaveResponse | void> {
    assertOnlineForRemote();
    return axios.post(`${API.periodicCheck}/save`, jsonToFormData(payload));
  }
}

export const periodicCheckRemote = new PeriodicCheckRemoteDataSource();
